import CommonModal from "../../../App/commonModal"
import React, { useEffect, useState } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import {get_profileInvitees, delete_profileInvitee} from "@/api/referral";
import { Table, Space, Modal } from "antd";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useIntl, FormattedMessage } from "react-intl";
import { toUtc } from "utils/date";
import CopyPagination from "../../../App/copyPagination"

const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl} = Util;
const { confirm } = Modal;

function InviteesModal (props) {
  const { isShowModal, onClose, getInviteCodeList, inviteCode } = props;
  const t = useTranslation();
  const [invitees, setInvitees] = useState([])
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false)
  const [userId, setUserId] = useState(null)
  const [hasPrev, setHasPrev] = useState(false)
  const [hasNext, setHasNext] = useState(false)
  const columns = [
    {
      title: t("home.friendId"),
      dataIndex: 'userId',
      key: 'userId',
    },
    {
      title: t("console.board.registerTime"),
      dataIndex: 'regTime',
      key: 'regTime',
      render: (time) => toUtc(time),
    },
    {
      title: t("home.isTrade"),
      dataIndex: 'isTrade',
      key: 'isTrade',
      render: (_, record) => (
        <Space size="middle">
          <span>{record.isTrade ? t("console.yes") : t("console.no")}</span>
        </Space>
      ),
    },
    // {
    //   title: t("home.action"),
    //   key: 'action',
    //   render: (_, record,index) => (
    //     <div className="rowItemAction">
    //       <span onClick={()=>showConfirm(record)} style={{ color: '#FD5760', cursor: 'pointer' }}>{t("console.delete")}</span>
    //     </div>
    //   ),
    // },
  ]

  const showConfirm = (record) => {
    // confirm({
    //   title: 'Do you Want to delete these items?',
    //   icon: <ExclamationCircleFilled />,
    //   onOk() {
    //     deleteInvitee(record.userId)
    //   },
    //   onCancel() {
    //     console.log('Cancel');
    //   },
    // });
    setUserId(record.userId)
    setIsShowDeleteModal(true)
  };

  const deleteInvitee = () =>{
    delete_profileInvitee({
      successPop: true,
      params: {
        inviteeUserId: userId
      }
    }).then(()=>{
      getProfileInvitees()
      getInviteCodeList()
      onDeleteClose()
    })
  }

  useEffect(()=>{
    const getData = async() => {
      getProfileInvitees()
    }
    getData()
  },[])

  const onPrev = () => {
    const fromId = invitees[0]?.id;

    const direction = 'PREV';
    if (fromId) {
      getProfileInvitees(direction, fromId);
    }
  };

  const onNext = () => {
    const direction = 'NEXT';
    const fromId = invitees[invitees.length - 1]?.id;

    if (fromId) {
      getProfileInvitees(direction, fromId);
    }
  };

  const getProfileInvitees = async(direction, fromId) => {
    const invitees = await get_profileInvitees({
      params: {
        inviteCode,
        limit: 5,
        direction,
        fromId
      }
    })
    setInvitees(invitees.items || [])
    setHasNext(invitees?.hasNext || false)
    setHasPrev(invitees?.hasPrev || false)
  }

  const onDeleteClose = () =>{
    setIsShowDeleteModal(false)
  }

  const onSave = () => {
    deleteInvitee()
  };

  return (
    <>
      <CommonModal width={516} title={t("home.friendList")} isShowModal={isShowModal} onClose={onClose}>
        <div className="InviteesModal">
          <Table pagination={false} size="small" dataSource={invitees} columns={columns} />
          {invitees.length != 0 && <div className="pagination">
            <CopyPagination
              position="center"
              hasPrev={hasPrev}
              hasNext={hasNext}
              onPrev={onPrev}
              onNext={onNext}
              isActivePage={true}
            />
          </div>}
        </div>
      </CommonModal>
      <CommonModal width={420} title={t("console.link.deleteInvited")} isShowModal={isShowDeleteModal} onClose={onDeleteClose} closable={false}>
        <div className="deleteInviteModal">
          <div className="sureDelete">
            <FormattedMessage
              id="home.sureDelete"
              values={{ userId }}
            />
          </div>
          <div className="foot1">
            <div className="cancel" onClick={onDeleteClose}>{t("home.cancel")}</div>
            <div className="save" onClick={onSave}>{t("home.save")}</div>
          </div>
        </div>
      </CommonModal>
    </>
  )

}

export default InviteesModal